export interface ICaseBattleJoinEvent {
  battleId: number;
  navigate: boolean;
  teamNumber?: number;
}
export interface ICaseBattleAddBotEvent {
  battleId: number;
  teamNumber?: number;
}
